<div class="lang-manager">
  <button class="lang-manager-button" [matMenuTriggerFor]="langMenu">
    <mat-icon class="lang-icon">language</mat-icon>
    <p class="active-lang-label">{{ activeLang | uppercase }}</p>
    <mat-icon class="lang-icon">arrow_drop_down</mat-icon>
  </button>
  <mat-menu class="lang-list" #langMenu="matMenu">
    @for (lang of langs; track lang.code) {
      <button mat-menu-item (click)="setLang(lang.code)">
        <span
          class="lang-item"
          [ngClass]="{ active: activeLang === lang.code }"
        >
          <svg-icon
            class="lang-flag"
            [name]="'flag-' + lang.code"
            [svgStyle]="{ 'height.px': 14, 'width.px': 21 }"
          ></svg-icon>
          {{ lang.name }}
        </span>
      </button>
    }
  </mat-menu>
</div>
